export enum TournamentType {
  None = 0,
  Municipal = 1,
  Departmental = 2,
  Provincial = 3,
  Regional = 4,
  National = 5,
}
